import { useAppDispatch, useAppSelector } from '@hooks';
import { Alert, AlertTitle, Snackbar } from '@mui/material';
import { hideAlert } from '@redux/actions';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const AppAlert: FC = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const { alert } = useAppSelector((state) => state.app);

  const handleClose = () => {
    dispatch(hideAlert());
  };

  return (
    <Snackbar
      open={alert.show}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      autoHideDuration={alert.type === 'success' ? 3000 : null}
      onClose={handleClose}
    >
      <Alert severity={alert.type} variant="filled" onClose={handleClose}>
        {alert.message && (
          <AlertTitle whiteSpace={'pre-line'}>
            {t('message.' + alert.message)}
          </AlertTitle>
        )}
      </Alert>
    </Snackbar>
  );
};

export default AppAlert;
